<template>
  <div>
    <v-flex class="pb-4 caption font-weight-bold">
      {{ text.title }}
    </v-flex>

    <v-flex offset-xs2 xs8 pb-3 @click="openLink">
      <v-img :src="qrcode" />
    </v-flex>
    <!-- {{ scbEasyLink }} -->
    <v-flex class="pb-4 body-1" style="text-align: left;" v-html="text.description" />
  </div>
</template>

<script>
export default {
  watch: {
    payplusLink(payplusLink) {
      if (payplusLink) {
        var now = new Date().valueOf()
        setTimeout(function () {
          if (new Date().valueOf() - now > 100) return
          // console.log(scbEasyLink.search('scbeasysim'))
          // if (scbEasyLink.search('scbeasysim') < 0) {
          //   if (navigator.userAgent.toLowerCase().indexOf('android') > -1) {
          //     window.location.href =
          //       'https://play.google.com/store/apps/details?id=com.scb.phone'
          //   } else if (
          //     navigator.userAgent.toLowerCase().indexOf('iphone') > -1
          //   ) {
          //     window.location.href =
          //       'https://apps.apple.com/th/app/scb-easy/id568388474'
          //   }
          // }
        }, 2500)
        // console.log(222)
        // console.log(JSON.stringify(scbEasyLink))
        //window.location = payplusLink
      }
    },
  },
  computed: {
    qrcode() {
      return require('@/assets/new-k-plus-logo.png')
      // if (!this.$store.state.scbEasyLink)
      //   return require('@/assets/ic_scb_easy.jpg')
      // return this.$store.state.scbEasyLink
    },

    payplusLink() {
      return this.$store.state.payplusLink || ''
    },

    text() {
      let obj = {}
      if (this.$store.state.language == 'EN') {
        obj = {
          title: 'Scan QR',
          description:
            'Just a moment, plaease do not close or refresh browser <br /> After success, the system will automatically return to home page.',
        }
      } else {
        obj = {
          title: 'กรุณาสแกนคิวอาร์ เพื่อชำระเงิน',
          description:
            'โปรดรอซักครู่ กรุณาอย่าปิดหน้าบราว์เซอร์ หรือทำการรีเฟรช <br /> หลังชำระเงินแล้ว ระบบจะทำการพาคุณกลับสู่หน้าหลัก',
        }
      }
      return obj
    },
  },
  methods: {
    openLink() {
      //window.location = this.payplusink
      window.open(this.payplusLink, '_blank')
    },
  },
}
</script>
